import { Component, OnInit, ViewChild, QueryList, ElementRef, ViewChildren, AfterViewInit, ChangeDetectorRef, ViewRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import * as Rx from 'rxjs';
import { Store } from '@ngrx/store';
import { FooterComponent } from '../../../common-components/footer/footer.component';
import { BreadcrumbComponent } from '../../../common-components/breadcrumb/breadcrumb.component';
import { HeaderComponent } from '../../../common-components/header/header.component';
@Component({
    selector: 'app-test-ui-component',
    templateUrl: './test-ui-component.html',
    styleUrls: ['./test-ui-component.scss'],
    imports: [HeaderComponent, BreadcrumbComponent, RouterOutlet, FooterComponent]
})
export class TestUIComponent  {

 

  constructor() {

  }


  
}
